

























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
@Component({ components: {} })
export default class DialogWebhookEventDetailsComponent extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  private get refs() {
    return refsService;
  }
  private get webhookEvent() {
    return this.refs.modules.contract.webhookEvent;
  }

  private formatJson(content: string) {
    try {
      const parsed =
        typeof content === 'string' ? JSON.parse(content) : content;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return content || '--';
    }
  }
}
